import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BelivpediaSearchRequest, IConfigSearch, Search } from "@core/models";
import { environment } from "environments/environment";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class MSSearchService{

    private currentConfigSubject: BehaviorSubject<IConfigSearch>;

    /**
     * Constructor
     * @param {HttpClient} _http
     * @param _configurationService
     */
    constructor(private _http: HttpClient) 
    {
        this.currentConfigSubject = new BehaviorSubject(null);
    }

    // getter: currentUserValue
    public get currentConfigValue(): IConfigSearch {
        return this.currentConfigSubject.value;
    }

    // getter: event current user value changed
    public get onCurrentConfigChanged(): Observable<IConfigSearch> {
        return this.currentConfigSubject.asObservable();
    }

    /**
     * Registra la configuración inicial de bix
     * @param {IConfigSearch} configuration Registra la configuración
     */
    register(config: IConfigSearch): void{
        this.currentConfigSubject.next(config);
    }

    /**
     * Función que realiza la busqueda en el buscador de azure
     * @param {number} userId Indica el id del usuario autenticado
     * @param {number} companyId Indica el id de la empresa del usuario autenticado
     * @param {string} text Indica el texto a buscar
     * @param {string} repository Indica el id del repositorio
     * @param {string} categories se envia las categorias
     * @param {number} skip los elementos que no deben mostrartse
     * @param {number} top la cantidad de elementos a mostrarse
     * @returns resultados de la busqueda
     */
    async search(userId: number, companyId: number, text: string = undefined, repository: string = undefined, categories: string =undefined,skip:number = 0,top:number = 9){

        const searchRequest: BelivpediaSearchRequest = {
            skip : skip,
            top : top,
            text : text,
            category : categories,
            repository : repository,
        };
        
        const result = await this._http.post<any>(`${environment.azureApiUrl}/api/azure-search`, searchRequest).toPromise();

        return result;

    }



}
